import { defineMessages } from 'react-intl'

export default defineMessages({
  noText: {
    id: 'components.MemoryRecordCard.noText',
    defaultMessage: 'No text',
  },
  stopRecordingTitle: {
    id: 'components.MemoryRecordCard.stopRecordingTitle',
    defaultMessage: 'Stop recording',
  },
  stopTitle: {
    id: 'components.MemoryRecordCard.stopTitle',
    defaultMessage: 'Stop',
  },
  playTitle: {
    id: 'components.MemoryRecordCard.playTitle',
    defaultMessage: 'Play',
  },
  reRecordTitle: {
    id: 'components.MemoryRecordCard.reRecordTitle',
    defaultMessage: 'Re-record',
  },
  submit: {
    id: 'components.MemoryRecordCard.submit',
    defaultMessage: 'Submit',
  },
  submitting: {
    id: 'components.MemoryRecordCard.submitting',
    defaultMessage: 'Submitting…',
  },
  uploading: {
    id: 'components.MemoryRecordCard.uploading',
    defaultMessage: 'Uploading…',
  },
  upload: {
    id: 'components.MemoryRecordCard.upload',
    defaultMessage: 'Upload',
  },
  startRecordingTitle: {
    id: 'components.MemoryRecordCard.startRecordingTitle',
    defaultMessage: 'Start recording',
  },
  cancelTitle: {
    id: 'components.MemoryRecordCard.cancelTitle',
    defaultMessage: 'Cancel',
  },
  recording: {
    id: 'components.MemoryRecordCard.recording',
    defaultMessage: 'Recording…',
  },
  dropHere: {
    id: 'components.MemoryRecordCard.dropHere',
    defaultMessage: 'Drop here',
  },
  record: {
    id: 'components.MemoryRecordCard.record',
    defaultMessage: 'Record',
  },
  cantRecord: {
    id: 'components.MemoryRecordCard.cantRecord',
    defaultMessage: "Can't record? Upload instead",
  },
  recordInstead: {
    id: 'components.MemoryRecordCard.recordInstead',
    defaultMessage: 'Record instead',
  },
})
